import Cropper from 'react-easy-crop';
import { useCallback, useState } from 'react';
import Slider from '@mui/material/Slider';
import Button from '@mui/material/Button';
import { Form } from 'react-bootstrap';
import { getCroppedImg, getSquaredImageWithBackground } from '../../utils/cropImageUtils';

const ImageCropper = ({ imageSrc, onCropComplete, onCancel }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [fillWithWhiteBackground, setFillWithWhiteBackground] = useState(false);

    const onCropCompleteInternal = useCallback((_, croppedPixels) => {
        setCroppedAreaPixels(croppedPixels);
    }, []);

    const handleDone = async () => {
        const croppedImage = fillWithWhiteBackground
            ? await getSquaredImageWithBackground(imageSrc)
            : await getCroppedImg(imageSrc, croppedAreaPixels);

        onCropComplete(croppedImage);
    };

    return (
        <div>
            <div style={{ position: 'relative', width: '100%', height: 400 }}>
                <Cropper
                    image={imageSrc}
                    crop={crop}
                    zoom={zoom}
                    aspect={1}
                    objectFit="contain"
                    onCropChange={setCrop}
                    onZoomChange={setZoom}
                    onCropComplete={onCropCompleteInternal}
                />
            </div>
            <div className="mt-3">
                <Form.Check
                    type="switch"
                    id="fill-white-background"
                    checked={fillWithWhiteBackground}
                    onChange={(e) => setFillWithWhiteBackground(e.target.checked)}
                    label="Completar con fondo blanco (sin recortar bordes)"
                    className="mb-3"
                />
                <Slider
                    value={zoom}
                    min={1}
                    max={3}
                    step={0.1}
                    onChange={(e, zoom) => setZoom(zoom)}
                    disabled={fillWithWhiteBackground}
                />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button variant="outlined" onClick={onCancel}>
                        Cancelar
                    </Button>
                    <Button variant="contained" onClick={handleDone}>
                        Recortar
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ImageCropper;
